<template>
  <div :class="[$b(), 'ignore-theme']">
    <div :class="[$b('inner'), 'global-wrapper']">
      <h2 :class="$b('heading')">
        <span :class="$b('heading', { highlight: true })">
          {{ productName }}
        </span>
        {{ $tr('Reviews.') }}
      </h2>
      <div :class="$b('reviews-container')">
        <div :class="$b('stars')">
          <ReviewStars
            :count="reviewSummary.count"
            :rating="reviewSummary.averageStars"
            gradient-light
            header-mode
          />
        </div>

        <div :class="$b('recommend')">
          <VisionIcon
            id="review-summnary-banner-thumbs-up"
            icon="thumbUp"
            theme="purple"
            gradient="default-light"
            :class="$b('recommend-icon')"
          />

          <BaseHeading
            tag="h2"
            size="h2"
            :class="$b('recommend-heading')"
          >
            {{ $tp(reviewSummary.recommendRate || 0.995) }}
          </BaseHeading>

          <BaseCopy
            tag="p"
            size="body"
            :class="$b('recommend-text')"
          >
            {{ $tr('would recommend SunGod to a friend') }}
          </BaseCopy>
        </div>
      </div>
      <LineLink
        is-button
        :class="$b('button')"
        @click="$emit('show-reviews')"
      >
        Read the Reviews
      </LineLink>
    </div>
  </div>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'

export default {
  name: 'ReviewSummaryBanner',
  props: {
    customisedProduct: { type: CustomisedProduct, required: true },
    reviewSummary: { type: Object, default: () => ({}) },
    titleOverride: { type: String, default: '' },
  },
  emits: ['show-reviews'],
  computed: {
    productName() {
      if (this.titleOverride) return this.titleOverride
      if (this.customisedProduct.product.useGenericReviews) return 'SunGod'
      if (this.customisedProduct.product.baseProduct?.name)
        return this.customisedProduct.product.baseProduct.name
      return this.customisedProduct.product.name
    },
  },
}
</script>

<style lang="postcss">
.ReviewSummaryBanner.ignore-theme {
  @apply bg-black text-white py-lg md:py-xl md:px-sm;

  .is-dark-chrome-theme & {
    @apply bg-off-black;
  }
}

.ReviewSummaryBanner__inner {
  @apply pb-md pt-sm lg:pb-xl lg:pt-lg;
}

.ReviewSummaryBanner__heading {
  @apply text-3xl md:text-4xl normal-case font-semibold leading-tighter tracking-tight
    mb-md md:mb-lg;

  &--highlight {
    @apply block md:inline mb-0 text-grey-600;
  }
}

.ReviewSummaryBanner__reviews-container {
  @apply grid grid-cols-1 md:grid-cols-2 gap-md;
}

.ReviewSummaryBanner__header-stars {
  @apply md:border-r md:border-off-black md:border-opacity-20;
}

.ReviewSummaryBanner__recommend {
  @apply flex flex-wrap justify-start items-center
    text-left;
}

.ReviewSummaryBanner__recommend-heading {
  @apply mt-0 ml-xs md:ml-sm;
}

.ReviewSummaryBanner__recommend-text {
  @apply mt-xxs
    w-full;
}

.ReviewSummaryBanner__recommend-icon {
  transform: translateY(-0.15em);
}

.ReviewSummaryBanner__button {
  @apply text-white text-base md:text-md
    mt-md lg:mt-lg;

  &::after {
    @apply bg-white;
  }

  &:hover {
    @apply text-white;
  }
}
</style>
